import {NavList} from '@primer/react'
import {memo} from 'react'

import type {StackSectionStackEntry} from '../../../helpers/merge-box-status-calculator/stack-section-status'
import type {RebaseState} from '../../../hooks/mutations/use-stack-rebase-mutation'
import {RebaseStateIcon} from './RebaseStateIcon'
import {RebaseStateLabel} from './RebaseStateLabel'
import {getRebaseStateLineClass} from './helpers/rebase-state-line-class'

export const RebasingStackEntryNavItem = memo(function RebasingStackEntryNavItemImpl({
  entry,
  rebaseState,
  previousRebaseState,
  tabSuffix,
}: {
  entry: StackSectionStackEntry
  rebaseState?: RebaseState
  previousRebaseState?: RebaseState
  tabSuffix: string
}) {
  return (
    <NavList.Item
      href={`${entry.pull.url}${tabSuffix}`}
      className={getRebaseStateLineClass(rebaseState, previousRebaseState)}
    >
      <NavList.LeadingVisual>
        <RebaseStateIcon state={rebaseState} />
      </NavList.LeadingVisual>
      <span className={rebaseState === undefined ? 'fgColor-muted' : ''}>{entry.pull.title}</span>
      <NavList.Description variant="block">
        <span className="fgColor-muted">
          #{entry.pull.number} · {entry.pull.headBranch}
        </span>
      </NavList.Description>
      <NavList.TrailingVisual>
        <RebaseStateLabel state={rebaseState} />
      </NavList.TrailingVisual>
    </NavList.Item>
  )
})
